import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import React from 'react'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const ModalStatus = ({useFetchInit}) => {

  const {
    globalStates,
    Actions,
    defaultData,
    Forms
  } = useFetchInit

  const {FormStatus:{formState, onInputChange ,onSelectSearchChange}} = Forms

  const {modalOpeningMode} = globalStates

  const {handleClickCloseModal, onSubmitFormStatus} = Actions

  return (
    <form onSubmit={onSubmitFormStatus}>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth> 
              <label htmlFor="fecha">* Fecha</label>
              <TextField
                  id='fecha'
                  name='fecha'
                  value={ formState.fecha }
                  onChange={ onInputChange }
                  size='small'
                  placeholder='Fecha'
                  hiddenLabel
                  type='date'
                  variant='outlined'
                  required
              />
          </FormControl>
        </Grid>
        
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
              <label htmlFor="disponibilidad">* Estado</label>
              <CustomAutocomplete 
                  customId="disponibilidad"
                  customName="disponibilidad"
                  customValue={formState.disponibilidad}
                  customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'disponibilidad', value: value.value }})}
                  customPlaceholder='Estado'
                  customOptions={
                      defaultData.optionsStatus.map(({ value, label }) => ({
                          value: value,
                          name: label
                      }))
                  }
                  customDisableClearable={true}
              />
          </FormControl>
        </Grid> 

        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
              <label htmlFor="ubicacion">* Ubicacion</label>
              <CustomAutocomplete 
                  customId="ubicacion"
                  customName="ubicacion"
                  customValue={formState.ubicacion}
                  customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'ubicacion', value: value.value }})}
                  customPlaceholder='Ubicacion'
                  customOptions={
                      defaultData.optionsLocation.map(({ value, label }) => ({
                          value: value,
                          name: label
                      }))
                  }
                  customDisableClearable={true}
              />
          </FormControl>
        </Grid> 

      
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl fullWidth>
            <label htmlFor="description">Descripcion</label>
            <TextField
                id='description'
                name='description'
                value={ formState.description } 
                onChange={onInputChange}
                size='small'
                placeholder='Descripcion'
                type='text'
                multiline
                rows={4}
                variant='outlined'
            />
            <Typography
              variant="caption"
              align="right"
              color={formState.description.length >= 500 ? 'error' : 'textSecondary'}
            >
              {formState.description.length} / 500
            </Typography> 
          </FormControl>
        </Grid>
      </Grid>

      <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }}>                
        <Grid item xs={12}>
          <div className="text-center">
            <Button 
                startIcon={<ArrowLeftCircle/>}
                variant="contained"
                type="button" 
                className='btn-round'
                color='warning'
                onClick={() => handleClickCloseModal(false, 'EDIT')} 
                sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
            >
                Volver
            </Button>
              
            {(modalOpeningMode==='EDITABLE') && (
                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="submit"
                    className='btn-round'
                    color='primary'
                    sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                >
                    {(formState.idestado>0) ? 'Actualizar' : 'Guardar'}
                </Button>
            )}
          </div>
        </Grid>
      </Grid>
                
    </form>
  )
}
